var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPDfSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf (4) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 0C5.175 0 4.5 0.675 4.5 1.5V22.5C4.5 23.325 5.175 24 6 24H21C21.825 24 22.5 23.325 22.5 22.5V6L16.5 0H6Z",
    fill: "#E4F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18 6H22.5L16.5 0V4.5C16.5 5.325 17.175 6 18 6Z",
    fill: "#3F51B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.5 19.5C19.5 19.9125 19.1625 20.25 18.75 20.25H2.25C1.8375 20.25 1.5 19.9125 1.5 19.5V12C1.5 11.5875 1.8375 11.25 2.25 11.25H18.75C19.1625 11.25 19.5 11.5875 19.5 12V19.5Z",
    fill: "#3F51B5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.76953 14.2099C4.76953 14.0119 4.92553 13.7959 5.17678 13.7959H6.56203C7.34203 13.7959 8.04403 14.3179 8.04403 15.3184C8.04403 16.2664 7.34203 16.7944 6.56203 16.7944H5.56078V17.5864C5.56078 17.8504 5.39278 17.9996 5.17678 17.9996C4.97878 17.9996 4.76953 17.8504 4.76953 17.5864V14.2099ZM5.56078 14.5511V16.0451H6.56203C6.96403 16.0451 7.28203 15.6904 7.28203 15.3184C7.28203 14.8991 6.96403 14.5511 6.56203 14.5511H5.56078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.21869 17.9994C9.02069 17.9994 8.80469 17.8914 8.80469 17.6281V14.2216C8.80469 14.0064 9.02069 13.8496 9.21869 13.8496H10.5919C13.3324 13.8496 13.2724 17.9994 10.6459 17.9994H9.21869ZM9.59669 14.5816V17.2681H10.5919C12.2112 17.2681 12.2832 14.5816 10.5919 14.5816H9.59669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M14.2445 14.6304V15.5836H15.7737C15.9897 15.5836 16.2057 15.7996 16.2057 16.0089C16.2057 16.2069 15.9897 16.3689 15.7737 16.3689H14.2445V17.6281C14.2445 17.8381 14.0952 17.9994 13.8852 17.9994C13.6212 17.9994 13.46 17.8381 13.46 17.6281V14.2216C13.46 14.0064 13.622 13.8496 13.8852 13.8496H15.9905C16.2545 13.8496 16.4105 14.0064 16.4105 14.2216C16.4105 14.4136 16.2545 14.6296 15.9905 14.6296H14.2445V14.6304Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M18.75 20.25H4.5V21H18.75C19.1625 21 19.5 20.6625 19.5 20.25V19.5C19.5 19.9125 19.1625 20.25 18.75 20.25Z",
    fill: "#CAD1D8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPDfSvg);
export default __webpack_public_path__ + "static/media/PDfSvg.6671c8bf4aa92333ea26961056ec66fc.svg";
export { ForwardRef as ReactComponent };